<template>
  <fragment>
    <div class="form-group">
      <div class="card-body">
        <label class="fontWeight">Action Date:</label>
        <el-date-picker
            v-model="comment.created_at"
            type="datetime"
            placeholder="Select Date"
            class="w-100 mb-2"
            value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>

        <label class="fontWeight">Comment:</label>
        <app-input class="col-sm-8"
                   type="text-editor"
                   v-model="comment.action_comment"
                   placeholder="Write Comment"
                   :required="true"/>
        <p class="fontStyle">
          <span class="fontWeight">Status: </span>
          {{ comment.status }}
        </p>
        <div class="mt-3">
          <div v-for="(file, fileIndex) in comment.applicant_files" :key="fileIndex" class="card mb-2 p-2" style="max-width: 300px; position: relative;">
            <button type="button" class="close" aria-label="Close" style="position: absolute; top: 5px; right: 10px;" @click.prevent="remove(fileIndex, file.id)">
              <span aria-hidden="true" style="color: red;">&times;</span>
            </button>
            <div class="d-flex align-items-center">
               <div class="mr-3">
                 <a :href="`/${file.fileURL}`" target="_blank">
                    <i class="el-icon-document" style="font-size: 2rem;"></i>
                 </a>
               </div>
               <div>
                 <a :href="`/${file.fileURL}`" target="_blank" class="text-truncate d-block" style="max-width: 180px;" :title="file.name">{{ file.name }}</a>
                 <div class="text-success small">
                   <i class="el-icon-circle-check"></i> Uploaded
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <label class="fontWeight">Select File:</label>
        <multi-upload
            ref="multiUpload"
            :uploadedFile="this.uploadedFile"
            :emailAddress="this.emailAddress"
        />
      </div>
    </div>
    <div class="form-group">
      <el-button class="secondary float-left ml-3 mt-2"
                 @click="saveComment()">
        Save/Update Comment
      </el-button>
      <el-button class="secondary float-left ml-3 mt-2"
                 @click="close()">
        Close
      </el-button>
    </div>
  </fragment>
</template>

<script>
import {Comment, File} from "@Views/Screening/utility/apiAgent";
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";
import MultiUpload from "@Views/Screening/ResuableComponents/MultiUpload.vue";

export default {
  name: "CustomizedGeneralComment",
  components: {
    MultiUpload
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    applicantId: {
      type: Number,
    },
    emailAddress: {
      type: String
    },
    steps: {
      type: Array
    }
  },
  data() {
    return {
      uploadedFile: [],
    };
  },
  methods: {
    updateCommentSteps,
    async saveComment() {
      if (this.comment.action_comment != '') {
        await this.$refs.multiUpload.submitUpload();
        
        // Ensure new files are moved into applicant_files array
        if (this.uploadedFile.length > 0) {
          this.uploadedFile.forEach(file => {
            this.comment.applicant_files.push(file);
          });
          this.uploadedFile = [];
        }

        const commentObj = {
          id: this.comment.id,
          action_comment: this.comment.action_comment,
          status: this.comment.status,
          created_at: this.comment.created_at,
          statusable_type: this.comment.statusable_type,
          statusable_id: this.comment.statusable_id,
          applicant_files: this.comment.applicant_files.map(file => file.id),
        };
        Comment.editComment(this.applicantId, this.comment.id, commentObj)
            .then(({data}) => {
              this.comment = {...commentObj};
              this.updateCommentSteps(commentObj, false);
              this.$toastr.s(data.message);
            });
      }
    },
    remove(fileIndex, applicantFileId) {
      File.deleteDocument(applicantFileId)
          .then(({data}) => {
            this.comment.applicant_files.splice(fileIndex, 1);
            this.$toastr.s(data.message);
          });
    },
    close() {
      this.$emit('close-comment-listing', false);
    }
  },
}
</script>

<style scoped>
.direction-input {
  direction: ltr;
}

.direction-label {
  text-align: left;
}

.fontStyle {
  font-size: 12px;
}

.errorStyle {
  font-weight: bolder;
  color: red;
}

.fontWeight {
  font-weight: bolder
}
</style>